import React from 'react';
export interface FooterProps {
  onHowItWorksClick?: () => void;
  onContactClick?: () => void;
}
export function Footer({
  onHowItWorksClick,
  onContactClick
}: FooterProps) {
  return <footer className="bg-brown-900 text-cream-400 py-16 border-t border-brown-800" data-id="element-160">
      <div className="max-w-7xl mx-auto px-4" data-id="element-161">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 mb-16" data-id="element-162">
          {/* Brand */}
          <div data-id="element-163">
            <span className="font-script text-3xl text-white relative block mb-6" data-id="element-164">
              Ihsanly
              <span className="absolute -top-1 left-20 text-accent-pink text-xl" data-id="element-165">
                *
              </span>
            </span>
            <p className="max-w-xs leading-relaxed" data-id="element-166">
              The modern audio guestbook for weddings. Capture voices, laughter,
              and love without the rental hassle.
            </p>
          </div>

          {/* Product */}
          <div data-id="element-167">
            <h4 className="text-white font-bold uppercase tracking-wider text-sm mb-6" data-id="element-168">
              Product
            </h4>
            <ul className="space-y-4" data-id="element-169">
              <li data-id="element-170">
                <button onClick={onHowItWorksClick} className="hover:text-white transition-colors" data-id="element-171">
                  How It Works
                </button>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div data-id="element-172">
            <h4 className="text-white font-bold uppercase tracking-wider text-sm mb-6" data-id="element-173">
              Support
            </h4>
            <ul className="space-y-4" data-id="element-174">
              <li data-id="element-175">
                <button onClick={onContactClick} className="hover:text-white transition-colors" data-id="element-176">
                  Help Center
                </button>
              </li>
              <li data-id="element-177">
                <button onClick={onContactClick} className="hover:text-white transition-colors" data-id="element-178">
                  Contact
                </button>
              </li>
              <li data-id="element-179">
                <a href="#" className="hover:text-white transition-colors" data-id="element-180">
                  About
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-brown-800 text-center text-sm" data-id="element-181">
          <p data-id="element-182">© 2025 Ihsanly. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}